import React from "react";
import ManageGallerySection from "./ManageGallerySection";

export default function ManageGallerySchoolLife() {
  return (
    <ManageGallerySection
      sectionKey="schoolLife"
      sectionTitle="Our School Life"
      sectionDescription="Upload, edit, and remove school life photos and videos."
    />
  );
}
